import { useSelector } from "react-redux";

import { getUserId } from "store/currentUser/currentUserSelector";

export default function useCurrentUserId(): number | null {
  return useSelector(getUserId);
}
